import { render, staticRenderFns } from "./ClientSms.vue?vue&type=template&id=4817be9e&"
import script from "./ClientSms.vue?vue&type=script&lang=js&"
export * from "./ClientSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports